export default __webpack_public_path__ + "static/media/background.441498ad.svg";